import React from 'react';
type EyebrowProps = {
  children: React.ReactNode;
  className?: string;
};
export function Eyebrow({
  children,
  className = ''
}: EyebrowProps) {
  return <p className={`text-[11px] font-semibold uppercase tracking-label text-accent ${className}`} data-id="element-42" data-mp="1pp3u2m0z8peb">
      {children}
    </p>;
}